// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-About----index-module---root---1xwHg","window":"src-components-About----index-module---window---2rO9O","viewport":"src-components-About----index-module---viewport---3q83j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/About/index.module.css
// module id = 451
// module chunks = 213534597649335